import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'
import { getAvailableItems } from '@backmarket/nuxt-layer-checkout/utils/cart/getAvailableItems'
import { isBouyguesOffer } from '@backmarket/nuxt-layer-checkout/utils/mobilePlan/isBouyguesOffer'
import { Breakpoint } from '@backmarket/utils/dom/getCurrentBreakpoint'

export function scrollToFirstItemWithCompliancyError(
  breakpointValue: Breakpoint,
  listingId: string,
) {
  const insuranceCompliancyElement = document.getElementById(
    `compliancy-${listingId}`,
  )
  const insuranceElement = document.getElementById(`insurances-${listingId}`)

  if (breakpointValue >= Breakpoint.MD) {
    insuranceElement?.scrollIntoView({ block: 'start', behavior: 'smooth' })

    return
  }
  insuranceCompliancyElement?.scrollIntoView({
    block: 'start',
    behavior: 'smooth',
  })
}

export function hasAvailableItems(items: CartItem[]): boolean {
  return getAvailableItems(items).length > 0
}

export function hasOutOfStockItem(items: CartItem[]): boolean {
  return items.some((item) => item.available === 'no')
}

function hasBouyguesMobilePlanOffer(item: CartItem) {
  if (!item.mobilePlan) return false

  return isBouyguesOffer(item.mobilePlan.selectedOffer)
}

export function getBouyguesMobilePlanOffer(cartItems: CartItem[]) {
  return cartItems.find(hasBouyguesMobilePlanOffer)?.mobilePlan?.selectedOffer
}
